export default "__VITE_ASSET__beb551b5__"